// @view/panels/document/RefinePage.panel.tsx
import React from "react";
import EmptyView from "@view/EmptyView";
import RefineComponent from "@view/document/Refine";
import type { DocumentRefineViewProps } from "@ps-bridge/contracts/documentRefine";

export type RefinePagePhase = "missing" | "ready";

type RefinePagePanelProps = {
  phase: RefinePagePhase;
  viewProps: DocumentRefineViewProps;
};

const RefinePagePanel: React.FC<RefinePagePanelProps> = ({ phase, viewProps }) => {
  const render = {
    missing: <EmptyView />,
    ready: <RefineComponent {...viewProps} />,
  } as const satisfies Record<RefinePagePhase, React.ReactElement>;

  return (
    <div data-testid="page-refine" data-page-state="ready" data-page-phase={phase}>
      {render[phase]}
    </div>
  );
};

export default RefinePagePanel;
